import { render } from "./salePay.vue?vue&type=template&id=108483b6&scoped=true"
import script from "./salePay.vue?vue&type=script&lang=js"
export * from "./salePay.vue?vue&type=script&lang=js"

import "./salePay.vue?vue&type=style&index=0&id=108483b6&lang=css"
import "./salePay.vue?vue&type=style&index=1&id=108483b6&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108483b6"]])

export default __exports__